import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
export const useIsDonationHistory = () => {
  const $ = _c(5);
  const isLogin = useAuthStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthQueryOptions["get:/wello/v2/auth/home-donation/history"]({
      query: {
        page: 1,
        size: 100
      }
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLogin) {
    t1 = {
      ...t0,
      enabled: isLogin,
      select: _temp2
    };
    $[1] = isLogin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: t2
  } = useQuery(t1);
  const donationHistoryCount = t2 === undefined ? 0 : t2;
  const isDonationHistory = donationHistoryCount > 0;
  let t3;
  if ($[3] !== isDonationHistory) {
    t3 = {
      isDonationHistory
    };
    $[3] = isDonationHistory;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(state) {
  return !!state.isLogin;
}
function _temp2(t0) {
  const {
    context
  } = t0;
  return context?.totalCount;
}